<template>
  <div>
    <h1 class="header-style">
      Check-in Records
    </h1>
    <p class="subheader-style">
      List of your check-in activities
    </p>
    <br>
    <user-activity />
  </div>
</template>
<script>
import UserActivity from './dialogComponents/UserActivityDialogs/UserActivity.vue';
export default {
  name: 'UserActivitiesPage',
  components: {
    'user-activity': UserActivity,
  },
};
</script>
